import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
import LayoutGenerator from "src/layouts";
import DashboardLayout from "src/layouts/dashboard";
import LogoOnlyLayout from "src/layouts/LogoOnlyLayout";
// layouts

// components
import LoadingScreen from "../components/LoadingScreen";
import PrintableWorkout from "src/components/printableWorkout/PrintableWorkout";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("/dashboard")} />}
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: "/welcome",
      element: <LayoutGenerator />,
      children: [
        { path: "home", element: <HomePage /> },
        { path: "freeze-active", element: <FreezeIsActivePage /> },
        { path: "out-of-region", element: <OutOfRegionPage /> },
      ],
    },
    {
      path: "/overview",
      element: <LayoutGenerator />,
      children: [
        { path: "nutrition-plan", element: <NutritionPlanPage /> },
        /*      { path: "meals", element: <MealsPage /> }, */
        { path: "meals-pdf", element: <PrintableNutrition /> },
        { path: "exercises-pdf", element: <PrintableWorkout /> },
        { path: "workout", element: <WorkoutPage /> },
        { path: "supplements", element: <SupplementsPage /> },
        { path: "explanation", element: <ExplanationPage /> },
      ],
    },
    {
      path: "/support",
      element: <LayoutGenerator />,
      children: [
        { path: "bug-report", element: <BugReportPage /> },
        { path: "request-support", element: <RequestSupportPage /> },
        { path: "inquires", element: <InquiresPage /> },
      ],
    },
    {
      path: "/account",
      element: <LayoutGenerator />,
      children: [{ path: "edit-profile", element: <EditProfilePage /> }],
    },
    {
      path: "/auth",
      element: <LogoOnlyLayout />,
      children: [
        { path: "signin", element: <SignInPage /> },
        { path: "signup", element: <SignUpPage /> },
        {
          path: "forgetpassword",
          element: <ForgetPassword />,
        },
        /* dd */
      ],
    },
    {
      path: "/form",
      element: <LayoutGenerator />,
      children: [
        { path: "custom-program", element: <ClientFormPage /> },
        { path: "form-submitted", element: <FormSubmittedPage /> },
      ],
    },

    {
      path: "*",
      element: <LogoOnlyLayout />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
    { path: "/", element: <Navigate to="/welcome/home" replace /> },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

// Overview
const HomePage = Loadable(lazy(() => import("../pages/HomePage")));
const NutritionPlanPage = Loadable(
  lazy(() => import("../pages/NutritionPlanPage"))
);
const PrintableNutrition = Loadable(
  lazy(() => import("../components/__printableNutrition/PrintableNutrition"))
);
const MealsPage = Loadable(lazy(() => import("../pages/MealsPage")));
const WorkoutPage = Loadable(lazy(() => import("../pages/WorkoutPage")));
const SupplementsPage = Loadable(
  lazy(() => import("../pages/SupplementsPage"))
);
// Support
const BugReportPage = Loadable(lazy(() => import("../pages/BugReportPage")));
const RequestSupportPage = Loadable(
  lazy(() => import("../pages/RequestSupportPage"))
);
const InquiresPage = Loadable(lazy(() => import("../pages/InquiresPage")));
// Account
const EditProfilePage = Loadable(
  lazy(() => import("../pages/EditProfilePage"))
);
// Authentication
const SignInPage = Loadable(lazy(() => import("../pages/authPages/SignIn")));
const SignUpPage = Loadable(lazy(() => import("../pages/authPages/SignUp")));
const ForgetPassword = Loadable(
  lazy(() => import("../pages/authPages/ForgetPassword"))
);
// Client Form
const ClientFormPage = Loadable(lazy(() => import("../pages/ClientFormPage")));
const FormSubmittedPage = Loadable(
  lazy(() => import("../pages/FormSubmittedPage"))
);
//explanation
const ExplanationPage = Loadable(
  lazy(() => import("../pages/ExplanationPage"))
);

const FreezeIsActivePage = Loadable(
  lazy(() => import("../pages/FreezeIsActivePage"))
);
const OutOfRegionPage = Loadable(
  lazy(() => import("../pages/OutOfRegionPage"))
);
const NotFound = Loadable(lazy(() => import("../pages/Page404")));
